export default "__VITE_ASSET__pqk3pQHE__"